// Central page catalog — used by Layout, Users page, and route guards.
// Admin users see everything. Other users are filtered by user.allowed_pages when set.
// If allowed_pages is null/undefined => role default (all except users).

export const PAGES = [
  { key: "dashboard", to: "/", label: "Dashboard" },
  { key: "parties", to: "/parties", label: "Parties" },
  { key: "products", to: "/products", label: "Products" },
  { key: "yarn", to: "/yarn", label: "Yarn Purchase" },
  { key: "knitting", to: "/batches/knitting", label: "Knitting" },
  { key: "dyeing", to: "/batches/dyeing", label: "Dyeing / Bleaching" },
  { key: "compacting", to: "/batches/compacting", label: "Compacting" },
  { key: "printing", to: "/batches/printing", label: "Printing" },
  { key: "dcs", to: "/dcs", label: "Delivery Challans" },
  { key: "cutting", to: "/cutting", label: "Cutting" },
  { key: "stitching", to: "/stitching", label: "Stitching" },
  { key: "packing", to: "/packing", label: "Packing" },
  { key: "stock", to: "/stock", label: "Finished Stock" },
  { key: "dispatch", to: "/dispatch", label: "Dispatch" },
  { key: "accessories", to: "/accessories", label: "Accessories" },
  { key: "ledger", to: "/ledger", label: "Party Ledger" },
  { key: "reports", to: "/reports", label: "Reports" },
  { key: "lots", to: "/lots", label: "Lot Trace" },
  { key: "settings", to: "/settings/company", label: "Company Settings" },
];

export function canAccess(user, pageKey) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (Array.isArray(user.allowed_pages) && user.allowed_pages.length > 0) {
    return user.allowed_pages.includes(pageKey);
  }
  // No restriction => role default (all pages except admin-only)
  return true;
}

export function firstAllowedPath(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/";
  const allowed = Array.isArray(user.allowed_pages) && user.allowed_pages.length > 0
    ? PAGES.filter((p) => user.allowed_pages.includes(p.key))
    : PAGES;
  return allowed[0]?.to || "/";
}
